import React from 'react';
import { useQuery } from 'react-query';
import { Loader } from '../../components/loader/Loader';
import { MainApp } from '../../components/mainApp/MainApp';
import { Category, getCategories } from '../../queries/categoriesQuery';
import { getMarkers } from '../../queries/markersQuery';
import { allId } from '../../shared/filterMarkers';

export const defaultCategory: Category = { color: '#8d1b3d', value: 'all', id: allId };

export const Home = () => {
  const categories = useQuery('categories', getCategories);
  const markers = useQuery('markers', getMarkers);
  const isDataLoading = categories.isLoading || markers.isLoading;

  if (isDataLoading) {
    return <Loader />;
  }

  return (
    <MainApp
      markers={markers.data}
      categories={categories.data}
      currentCategory={defaultCategory}
    />
  );
};
